module.exports = __webpack_public_path__ + "static/img/01-banner.1d854b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-companyInfo/01-banner.jpg
// module id = 1384
// module chunks = 1